module.exports = __webpack_public_path__ + "static/img/Q22025ProspectdldUsed.2e8e673.jpg";